<template>
  <modal
    effect="fade/zoom"
    cancelText="Fermer"
    okText="Enregistrer"
    v-model="isOpen"
    @ok="newBillingOrder"
    @cancel="$emit('close')"
    large
  >
    <div slot="modal-header" class="modal-header row m-0">
      <h4 class="modal-title col-8">Ajouter une commande de facturation</h4>

      <div
        class="col-4 d-flex flex-column align-items-end"
        style="padding-top: 17px"
      >
        <div class="pull-right d-flex flex-wrap justify-content-end">
          <div v-if="!form.isCredit" class="form-group d-inline-block mr-1">
            <div class="form-group d-inline-block">
              <span class="mr-1"><i class="icon-envelope"></i> Email</span>
              <label
                class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
              >
                <input
                  type="checkbox"
                  class="switch-input"
                  v-model="form.sendEmail"
                  :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
                />
                <span class="switch-label" data-on="On" data-off="Off"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex">
      <div class="col-sm-6">
        <div class="row">
          <div class="form-group col-sm-12">
            <label>Société</label>

            <v-select
              v-model="form.merchantId"
              :class="this.formErrors.merchantId ? 'has-error' : ''"
              :options="merchantsOptions"
              @input="handleMerchantChange"
            ></v-select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-12">
            <label>Concept</label>

            <v-select
              v-model="form.concept"
              :class="this.formErrors.concept ? 'has-error' : ''"
              :options="conceptsOptions"
              @input="updatePaymentMethods()"
            >
              <span slot="no-options"
                >Sélectionnez une option pour Société.</span
              >
            </v-select>
          </div>
        </div>

        <div class="row" style="margin-top: 33px">
          <div class="form-group col-sm-6">
            <label>Prix *</label>

            <div
              class="input-group"
              :class="this.formErrors.price ? 'has-error' : ''"
            >
              <input
                v-model="form.price"
                type="text"
                class="form-control"
                @input="(e) => formPriceInput(e.target.value)"
              />

              <span class="input-group-addon"><i class="fa fa-euro"></i></span>
            </div>

            <small class="text-danger" v-if="form.isCredit">
              Avoir de <strong>{{ form.price }}&euro;</strong>, une facture sera
              générée directement.
            </small>
          </div>

          <div v-if="!form.isCredit" class="form-group col-sm-6">
            <label style="width: 100%">
              Première échéance

              <a class="pull-right" href="#" @click="createSubPayments">
                <i class="fa fa-refresh"></i>
              </a>
            </label>

            <datepicker
              v-model="form.paymentData.wishedDay"
              format="dd.MM.yyyy"
              language="fr"
              input-class="form-control"
            ></datepicker>
          </div>
        </div>

        <div v-if="!form.isCredit" class="row">
          <div class="form-group col-sm-12">
            <label> Nombre d'échéances </label>

            <div class="input-group">
              <input
                v-model="form.paymentData.countPayments"
                type="number"
                min="1"
                max="20"
                class="form-control"
                @input="createSubPayments"
              />
            </div>
          </div>
        </div>

        <div
          class="alert alert-danger mx-1"
          v-if="formErrors.paymentDescription || formErrors.paymentType"
        >
          Veuillez ajouter une description (si CB) ou un mode (si pas CB) aux
          paiements.
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="form-group col-sm-12">
            <label>Pack</label>

            <v-select
              v-model="form.session"
              :class="this.formErrors.session ? 'has-error' : ''"
              :options="sessions"
              @input="(e) => createSubPayments(e)"
            ></v-select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-12">
            <label> Description commande (visible facturation) </label>

            <v-select
              style="margin-bottom: 5px"
              :options="client.orderDescriptions"
              v-model="client.billing.label"
              @input="updateBillingDescriptionForB2B"
            ></v-select>

            <textarea
              v-model="client.billing.description"
              type="text"
              class="form-control"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-sm-12">
            <label>Menu / Statistique *</label>
            <v-select
              v-model="form.menuStat"
              :options="menuStatsOptions"
              label="label"
              :selectable="(option) => !option.disable"
              :class="this.formErrors.menuStat ? 'has-error' : ''"
              :disabled="form.isCredit"
            />
          </div>
        </div>

        <div v-if="!form.isCredit" class="row">
          <div class="form-group col-sm-4">
            <label> Paiement CB </label>
            <div class="input-group" style="padding-top: 7px">
              <label
                class="switch switch-sm switch-text switch-info float-right mb-0 mr-0"
              >
                <input
                  type="checkbox"
                  class="switch-input"
                  v-model="form.paymentData.isCB"
                  :disabled="!hasPermission($store.state.user, 'ORDERS_WRITE')"
                  @change="createSubPayments"
                />

                <span class="switch-label" data-on="On" data-off="Off"></span>

                <span class="switch-handle"></span>
              </label>
            </div>
          </div>

          <div
            v-if="form.paymentData.isCB && !form.isCredit"
            class="form-group col-sm-8"
          >
            <label style="width: 100%">
              Description Paiement

              <a class="pull-right" href="#" @click="createSubPayments">
                <i class="fa fa-refresh"></i>
              </a>
            </label>

            <input
              v-model="form.paymentData.description"
              type="text"
              class="form-control"
            />
          </div>

          <div class="form-group col-sm-8" v-else>
            <div class="form-group" style="position: relative">
              <label style="width: 100%">
                Choix du mode de paiement (par défaut)

                <a class="pull-right" href="#" @click="createSubPayments">
                  <i class="fa fa-refresh"></i>
                </a>
              </label>

              <div class="input-group">
                <span class="input-group-addon">Paiement par</span>

                <select
                  v-model="form.paymentData.type"
                  class="form-control"
                  @change="createSubPayments"
                >
                  <option
                    :key="key"
                    v-for="(pm, key) in paymentMethods"
                    :value="pm.name"
                  >
                    {{ pm.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-table :data="form.payments" v-if="!form.paymentData.isAI">
      <el-table-column label="Prix" width="100">
        <template slot-scope="scope"> {{ scope.row.price }} € </template>
      </el-table-column>
      <el-table-column label="CB" align="center" width="40">
        <template slot-scope="scope">
          <input
            class="form-control"
            type="checkbox"
            v-model="scope.row.isCB"
            @input="clearPaymentType(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="Description" width="200">
        <template slot-scope="scope">
          <input
            class="form-control"
            type="text"
            v-model="scope.row.type"
            :disabled="!scope.row.isCB"
          />
        </template>
      </el-table-column>
      <el-table-column label="Date de prélèvement" width="170">
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.deadline"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            type="date"
          />
        </template>
      </el-table-column>
      <el-table-column label="Mode">
        <template slot-scope="scope">
          <select
            v-if="!scope.row.isCB"
            v-model="scope.row.type"
            class="form-control"
          >
            <option
              :key="key"
              v-for="(pm, key) in paymentMethods"
              :value="pm.name"
            >
              {{ pm.name }}
            </option>
          </select>
        </template>
      </el-table-column>

      <el-table-column label="Séances" width="125">
        <template slot-scope="scope">
          <input
            v-model="scope.row.nbSessions"
            type="number"
            class="form-control"
            @input="(e) => formPaymentAiSessionInput(e.target.value, scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

import Modal from "vue-strap/src/Modal";

export default {
  components: {
    Modal,
    Datepicker,
  },

  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    clientData: {
      type: Object,
      required: true,
    },
    merchantsData: {
      type: Array,
      required: true,
    },
    conceptsData: {
      type: Array,
      required: true,
    },
    isB2BBilling: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      client: null,
      conceptsOptions: [],
      isOpen: false,
      formSending: false,
      paymentMethods: [],
      sessions: [],

      form: {
        client: null,
        concept: "Corporate",
        description: null,
        menuStat: null,
        merchantId: null,
        payments: [],
        paymentData: {
          countPayments: 1,
          description: null,
          isCB: true,
          type: null,
          wishedDay: moment().add("15", "days").format(),
        },
        price: null,
        sendEmail: true,
        session: null,
      },

      formErrors: {
        client: null,
        menuStat: null,
        merchantId: null,
        missingType: null,
        concept: null,
        session: null,
        price: null,
        paymentDescription: null,
        paymentType: null,
      },
    };
  },

  computed: {
    ...mapGetters({
      menuStatsOptions: "getMenuStatsOptions",
    }),

    merchantsOptions() {
      return this.merchantsData.map((m) => ({
        label: m.name,
        value: m.id,
      }));
    },
  },

  watch: {
    isShow(newVal) {
      this.isOpen = newVal;
    },

    clientData(newVal) {
      this.client = newVal;
    },
  },

  async created() {
    this.client = this.clientData;
    this.isOpen = this.isShow;

    await this.defaultSelectionInputs();

    for (let i = 1; i <= 200; i++) {
      this.sessions.push({
        label: this.formatPack(i.toString()),
        value: i.toString(),
      });

      if (!this.form.session) {
        this.form.session = this.sessions[0];
      }
    }
  },

  methods: {
    async defaultSelectionInputs() {
      const merchantId = this.isB2BBilling
        ? this.$store.state.merchantIds.corporate
        : this.$store.state.merchantIds.company;

      const conceptName = () => {
        if (this.isB2BBilling && this.client.marketEstablishment) {
          this.form.menuStat = this.menuStatsOptions.find(
            (m) => m.value === "pack-fidelisation"
          );

          return "Collectivités";
        }

        if (this.isB2BBilling) {
          if (this.client.orders.length > 0) {
            this.form.menuStat = this.menuStatsOptions.find(
              (m) => m.value === "pack-fidelisation"
            );
          } else {
            this.form.menuStat = this.menuStatsOptions.find(
              (m) => m.value === "pack-conversion"
            );
          }

          return "Corporate";
        }

        if (this.client.orders.filter((o) => o.discovery).length === 1) {
          this.form.menuStat = this.menuStatsOptions.find(
            (m) => m.value === "pack-conversion"
          );
        }

        if (this.client.orders.length > 1) {
          this.form.menuStat = this.menuStatsOptions.find(
            (m) => m.value === "pack-fidelisation"
          );
        }

        return "justcoaching.fr";
      };

      const concept = this.conceptsData.find((c) => c.name === conceptName());
      const merchant = this.merchantsData.find((m) => m.id === merchantId);

      this.form.merchantId = {
        label: merchant?.name || "",
        value: merchant?.id || "",
      };
      this.form.concept = concept?.name || "";

      await this.handleMerchantChange(this.form.merchantId);
      await this.updatePaymentMethods();
    },

    updateBillingDescriptionForB2B(value) {
      this.client.billing = {
        ...this.client.billing,
        description: value ? value.description : "",
        label: value ? value.label : "",
      };
    },

    formPriceInput(value) {
      this.form.price = this.formatFormPrice(value);
    },

    async handleMerchantChange(merchant) {
      this.conceptsOptions = [];

      if (merchant?.value) {
        this.conceptsOptions = this.conceptsData
          .filter((c) =>
            c.merchants?.some((m) => m.merchantId === merchant.value)
          )
          .map(({ name }) => name);
      }
    },

    async updatePaymentMethods() {
      const { data } = await this.$api.get("/payment-methods/by-concept", {
        params: { concept: this.form.concept },
      });

      this.paymentMethods = data;
    },

    createSubPayments(e) {
      if (e && typeof e.preventDefault === "function") e.preventDefault();

      if (
        !this.form.session?.value ||
        !this.form.price ||
        parseFloat(this.form.price) <= 0
      ) {
        this.form.payments = [];
        this.form.paymentData.sessionPrice = null;
        return;
      }

      if (!this.form.isCredit && this.form.price) {
        const payments = [];

        const globalPrice = parseFloat(this.form.price);
        const nbPaiement = parseInt(this.form.paymentData.countPayments);

        const sessionPrice = globalPrice / this.form.session.value;
        const quotient = Math.floor(this.form.session.value / nbPaiement);
        const remainder = this.form.session.value % nbPaiement;

        let type = this.form.paymentData.type;
        let deadline = moment(this.form.paymentData.wishedDay).format();

        if (this.form.paymentData.isCB) {
          type = this.form.paymentData.description;
        }

        for (let index = 0; index < nbPaiement; index++) {
          let total = sessionPrice * quotient;
          let countSession = quotient;

          if (index < remainder) {
            total = (quotient + 1) * sessionPrice;
            countSession = quotient + 1;
          }

          payments.push({
            price: total.toFixed(2),
            captured: false,
            type,
            alert: true,
            alertMessage: "",
            deadline,
            isCB: this.form.paymentData.isCB,
            isAI: this.form.paymentData.isAI,
            nbSessions: countSession,
          });

          deadline = moment(deadline).add(1, "M").format();

          this.form.paymentData.sessionPrice = sessionPrice;

          this.form.payments = payments;
        }
      }
    },

    formValidator() {
      this.formErrors = {
        client: !this.form.client,
        concept: !this.form.concept,
        menuStat: !this.form.isCredit && !this.form.menuStat,
        merchantId: !this.form.merchantId,
        paymentDescription: this.form.paymentData.isCB
          ? !this.form.paymentData.description
          : false,
        paymentType: !this.form.paymentData.isCB
          ? !this.form.paymentData.type
          : false,
        price: !this.form.isCredit && !this.form.price,
        session: !this.form.isCredit && !this.form.session,
      };

      if (
        !this.form.isCredit &&
        this.form.payments &&
        this.form.payments.length > 0
      ) {
        if (this.form.payments.find((p) => !p.type)) {
          this.formErrors.missingType = true;
        } else {
          this.formErrors.missingType = false;
        }

        this.formErrors.paymentsDifference = !!this.paymentsDifference;
      } else {
        this.formErrors.missingType = false;
        this.formErrors.paymentsDifference = false;
      }

      return (
        Object.values(this.formErrors).filter((error) => error).length === 0
      );
    },

    async newBillingOrder() {
      this.form.client = this.client.email;
      this.form.description =
        "Facturation de " +
        this.form.session.label +
        "\n\n" +
        this.client.billing.description;

      const commercial = this.$store.state.user.commercial?.isCommercial
        ? this.$store.state.user.email
        : this.client.commercials.sort((a, b) =>
            moment(b.relatedSince).diff(moment(a.relatedSince))
          )[0].user;

      if (!this.formValidator() || this.formSending) {
        this.$errorToast("Les champs entourés en rouge sont obligatoires");

        return;
      }

      const isConversion =
        this.form.menuStat &&
        this.form.menuStat.value &&
        (this.form.menuStat.value === "decouverte" ||
          this.form.menuStat.value === "one-shot");

      const isAcquisition =
        this.form.menuStat &&
        this.form.menuStat.value &&
        (this.form.menuStat.value === "decouverte" ||
          this.form.menuStat.value === "pack-conversion" ||
          this.form.menuStat.value === "one-shot" ||
          this.form.menuStat.value === "autres");

      const isFidelisation =
        this.form.menuStat &&
        this.form.menuStat.value &&
        (this.form.menuStat.value === "pack-conversion" ||
          this.form.menuStat.value === "pack-fidelisation" ||
          this.form.menuStat.value === "one-shot");

      try {
        this.$emit("orderLoading", true);
        this.formSending = true;

        const { data } = await this.$api.post("/orders", {
          client: this.form.client,
          commercial,
          concept: this.form.concept,
          description: this.form.description,
          isConversion,
          isCredit: this.form.isCredit,
          isAcquisition,
          isFidelisation,
          isOneShotEvent: this.form.menuStat?.value === "one-shot",
          merchantId: this.form.merchantId.value,
          payments: this.form.payments,
          price: this.form.price.replace(",", "."),
          session: this.form.session.value,
          isForBillingOnly: true,
        });

        if (!this.form.isCredit && this.form.sendEmail) {
          this.$confirm({
            message: "Envoyer un email pour informer le client ?",
            onConfirm: async () => {
              await this.$api.post(`/orders/send-creation-email/${data.id}`);
            },
          });
        }

        this.$emit("success");
        this.$emit("close");
      } catch (err) {
        this.formSending = false;

        this.$errorToast(
          err.response?.data?.message ||
            "Une erreur est survenue lors de la création de la commande."
        );
      } finally {
        this.$emit("orderLoading", false);
      }
    },
  },
};
</script>
